// @flow

import * as React from 'react';

import InputAdornment from '@mui/material/InputAdornment';
import * as icons from 'app/common/icons';

type Props = {
  icon: string,
  position?: 'start' | 'end'
};

class Adornment extends React.PureComponent<Props> {
  render() {
    const { icon, position = 'start' } = this.props;
    const Icon = icons[icon];
    return (
      Icon && (
        <InputAdornment position={position}>
          <Icon style={{ opacity: 0.4 }} />
        </InputAdornment>
      )
    );
  }
}

export default Adornment;